import React, { useEffect, useState } from "react";
import TeacherProfilePreviewV2 from "../teacherJourney/profile-preview/preview-2";
import { useParams } from "react-router-dom";
import { fetchTeacherAllData } from "../../services/teacher";
import { getDocumentUrls } from "../../helper";
import CenterLoading from "../../components/loader/CenterLoader";
import useUserStatus from "../../helper/use-user-status";

const TeacherPublicPreview = () => {
  const { id } = useParams();
  const userStatus = useUserStatus(id);

  const [loading, setLoading] = useState(true);
  const [teacherData, setTeacherData] = useState({});

  useEffect(() => {
    if (id) {
      getTeacherAllData(id);
    }
  }, [id]);

  const addNameToMedia = (name, media) => {
    let updatedData = media?.map((item) => {
      return {
        ...item,
        name,
      };
    });
    return updatedData;
  };

  const groupSlotsByDay = (data) => {
    const daysOfWeek = [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
      "Sunday",
    ];
    const formattedData = data?.reduce((acc, item) => {
      if (item?.day && item?.startTime && item?.endTime && item?.isEnabled) {
        const formattedSlot = {
          startTime: new Date(
            `1970-01-01T${item?.startTime}Z`
          ).toLocaleTimeString("en-US", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          }),
          endTime: new Date(`1970-01-01T${item?.endTime}Z`).toLocaleTimeString(
            "en-US",
            { hour: "2-digit", minute: "2-digit", hour12: true }
          ),
        };
        const dayIndex = daysOfWeek.indexOf(item?.day);
        if (dayIndex !== -1) {
          if (!acc[dayIndex]) {
            acc[dayIndex] = { day: item.day, slots: [formattedSlot] };
          } else {
            acc[dayIndex].slots.push(formattedSlot);
          }
        }
      }
      return acc;
    }, []);

    // Remove undefined entries if any and return the result
    return formattedData?.filter(Boolean);
  };

  const getTeacherAllData = async (teacherId) => {
    try {
      const { status, data } = await fetchTeacherAllData(teacherId);
      if (status === 200) {
        // filter media based on type and put Name prop. on it
        let cnicPicture = addNameToMedia(
          "CNIC",
          getDocumentUrls(data?.data?.teacherMedia, "cnicPicture")
        );
        let educationalDocument = addNameToMedia(
          "Educational Document",
          getDocumentUrls(data?.data?.teacherMedia, "educationalDocument")
        );
        let certificatePicture = addNameToMedia(
          "Certificates",
          getDocumentUrls(data?.data?.teacherMedia, "certificatePicture")
        );
        let introVideos = addNameToMedia(
          "intro Video",
          getDocumentUrls(data?.data?.teacherMedia, "introVideos")
        );
        let demoVideos = addNameToMedia(
          "Demo Video",
          getDocumentUrls(data?.data?.teacherMedia, "demoVideos")
        );

        let mergedMedia = [
          // merge media
          ...cnicPicture,
          ...educationalDocument,
          ...certificatePicture,
          ...introVideos,
          ...demoVideos,
        ];
        setTeacherData({
          ...data?.data,
          profilePic:
            getDocumentUrls(data?.data?.teacherMedia, "profilePicture")?.[0]
              ?.url || "https://via.placeholder.com/150",
          media: mergedMedia,
          teachingSlots: groupSlotsByDay(data?.data?.teacherAvailabilities),
        });
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <div className="px-4 py-4">
      {loading ? (
        <CenterLoading />
      ) : (
        <>
          <TeacherProfilePreviewV2
            teacherData={teacherData}
            online={userStatus === "online"}
          />
        </>
      )}
    </div>
  );
};

export default TeacherPublicPreview;
